import script from "./SnackForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./SnackForm.vue?vue&type=script&lang=ts&setup=true"

import "./SnackForm.vue?vue&type=style&index=0&id=7d90c24c&lang=scss"

const __exports__ = script;

export default __exports__